import { Chart, Plugin } from 'chart.js';

type DelayedResizeChart = Chart & { _doResize?: (mode: string) => number; $cancelResizeDelay?: () => void };

const firstUpdateDone = new WeakSet<Chart>();

export const resizeDelayGuardPlugin: Plugin = {
  id: 'resizeDelayDestroyGuard',
  beforeInit(chart: Chart) {
    const target = chart as DelayedResizeChart;
    let handle: ReturnType<typeof setTimeout>;
    const updateIfAlive = (mode: string) => target.canvas && target.update(mode as 'resize');
    target._doResize = (mode: string) => {
      clearTimeout(handle);
      if (!firstUpdateDone.has(target)) {
        handle = setTimeout(() => !firstUpdateDone.has(target) && updateIfAlive(mode), 0);
        return 0;
      }
      const delay = Chart.defaults.resizeDelay || 0;
      handle = setTimeout(() => updateIfAlive(mode), delay);
      return delay;
    };
    target.$cancelResizeDelay = () => clearTimeout(handle);
  },
  afterUpdate(chart: Chart) {
    firstUpdateDone.add(chart);
  },
  beforeDestroy(chart: Chart) {
    (chart as DelayedResizeChart).$cancelResizeDelay?.();
  },
};
